/* eslint-disable react/iframe-missing-sandbox */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable prefer-destructuring */
/* eslint-disable guard-for-in */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-duplicate-imports */
import {
  Box,
  Grid,
  Dialog,
  IconButton,
  Typography,
  DialogActions,
  DialogContent,
  FormHelperText,
  Autocomplete
} from '@mui/material';
import React, { ChangeEvent, FC, useCallback, useEffect, useMemo, useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { UiInput, UiSelect, UiSwitch } from '../../../../../components/ui/atoms';
import { Controller, FieldValues, SubmitHandler, useForm } from 'react-hook-form';
import { API } from '../../../../../api';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import { articleActions, fetchAllArticles } from '../../../../../redux/slices/article/getAllArticleSlice';
import { toast } from 'react-toastify';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import upload from '../../../../../assets/images/upload.svg';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { AtomicBlockUtils, ContentState, EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { ImageBlock } from '../../Program/components/program tabs/settings components/TaskPreviewRightBar';
import { Close } from '@mui/icons-material';
import { FileOutlined } from '@ant-design/icons';
import _ from 'lodash';
import htmlToDraft from 'html-to-draftjs';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import {
  GroupBasedRoleFormatter,
  handleImageCompression,
  imageSizeLimit,
  industryArray,
  roleNameFormatter,
  topicArray
} from '../../../components/common';
import CommonModalHeader from '../../../../../components/DialogUi/CommonModalHeader';
import DosenInput from '../../../components/DosenInput';
import DosenAutocomplete from '../../../components/DosenAutocomplete';

const imgSize = imageSizeLimit();
const acceptedImages = 'image/jpeg,image/jpg,image/png';
interface Props {
  openForm: boolean;
  handleClickCloseForm: any;
  setOpenForm: any;
  selectedActiveId: any;
  singleListData: any;
  action: any;
  setAction: any;
  onNewArticleCreated?: any;
  newGroupId?: string
}

const schema = yup.object().shape({
  articleName: yup.string().required('Article name is required'),
  type: yup.string().required('Article type is required'),
  readTime: yup.string().required('Read time is required'),
  authorName: yup.string().required('Author Name is required'),
  // accessFor: yup.string().required('Who Can View is required'),
  articleViewableTo: yup.string().required('Who can view is required'),
  articleViewableUserType: yup
    .array()
    .min(1, 'Which members can access is required')
    .required('Which members can access is required'),
  topic: yup.string().optional(),
  articleDescription: yup.string().required('Article Description is required'),
  // articleDescription: yup.string(),
  coverImg: yup.mixed().required('Cover image is required')
});
const toolBarStyle = {
  border: 'none',
  backgroundColor: 'rgb(247, 244, 244)',
  padding: '10px 0',
  marginBottom: 0,
  borderBottomLeftRadius: '10px',
  borderBottomRightRadius: '10px'
};

const AddEditContent: FC<Props> = ({
  openForm,
  handleClickCloseForm,
  setOpenForm,
  selectedActiveId,
  singleListData,
  action,
  onNewArticleCreated,
  newGroupId
}: Props) => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const grpId = params.id || '';
  const coId = params.coId || '';
  const orgId = params.orgId || '';
  const resolvedGroupId = React.useMemo(() => {
    const baseGroupId = grpId && grpId !== 'admin' ? grpId : coId;
    console.log({newGroupId, baseGroupId})
    return newGroupId || baseGroupId;
  }, [grpId, coId, newGroupId]);
  const manualBuilderGroupId = useAppSelector((state) => state.orgDetails.data?.grpId);
  const [addEditSubmitLoader, setAddEditSubmitLoader] = useState(false);
  const [coverImageUrl, setCoverImageUrl] = useState<File | null>(null);
  const [isPublished, setIsPublished] = useState(true);
  const [videoFile, setVideoFile] = useState<File | null>(null);
  const [audioFile, setAudioFile] = useState<File | null>(null);
  const [textFile, setTextFile] = useState<any>(null);
  const [textFileUrl, setTextFileUrl] = useState<any>(null);
  const [urlName, setUrlName] = useState('');
  const [textFileError, setTextFileError] = useState<string | null>(null);
  const [type, setType] = useState('');
  const [readTimeValue, setReadTimeValue] = useState('');
  const [imgError, setImgError] = useState('');

  const [viewFor, setViewFor] = useState('');
  const [editCoverImg, setEditCoverImg] = useState<string>();
  const [editVideoUrl, setEditVideoUrl] = useState<File | null>(null);
  const [videoError, setVideoError] = useState<string | null>(null);
  const [editAudioUrl, setEditAudioUrl] = useState<File | null>(null);
  const [audioError, setAudioError] = useState<string | null>(null);

  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const blobTextFileUrl = textFile ? URL.createObjectURL(textFile) : null;

  const TagList = ['General', 'Product Tutorials', 'Case Studies', 'Testimonials', 'Program Materials'];
  const roleOptions = ['mentee', 'mentor', 'admin', 'All Users'];
  const mentorRoleText = GroupBasedRoleFormatter('mentor', 'Mentor');
  const menteeRoleText = GroupBasedRoleFormatter('mentee', 'Mentee');

  const groupData = useAppSelector((state) => state.groupDetails);
  const topics = topicArray();
  const industries = industryArray();
  const topicOptions = groupData?.data?.subjects?.topics || topics || [];
  const industryOptions = groupData?.data?.subjects?.industries || industries || [];

  const checkError = (fieldName: string) => Boolean(errors[fieldName]);
  const getError = (fieldName: string) => errors[fieldName]?.message;

  useEffect(() => {
    setType('');
    setReadTimeValue('');
    setViewFor('');
  }, []);

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    clearErrors,
    getValues,
    reset,
    watch,
    setError
  } = useForm({
    resolver: yupResolver(schema)
  });

  const safeUrlName = urlName || '';
  let filename = safeUrlName.substring(safeUrlName.lastIndexOf('/') + 1);
  filename = filename.split('.')[0];
  filename = filename.replace(/^\d+_/, '');
  filename = filename.replace(/%20/g, ' ');

  const watchArticleType = watch('type');

  const onSubmit: SubmitHandler<FieldValues> = async (value) => {
    setAddEditSubmitLoader(true);
    const formData = new FormData();
    formData.append('articleName', value.articleName);
    formData.append('type', value.type);
    formData.append('authorName', value.authorName);

    if (coverImageUrl) {
      formData.append('coverImage', coverImageUrl);
    }

    formData.append('readTime', value.readTime);
    formData.append('articleDescription', value.articleDescription);

    const selectedIndustries = Array.isArray(value.industries)
      ? value.industries
      : value.industries
      ? [value.industries]
      : [];
    if (selectedIndustries.length) {
      const industryPayload = selectedIndustries.map((each: any) => {
        const industry = industries.find((tag) => tag.label === each);
        return industry?.name || each;
      });
      formData.append('industries', JSON.stringify(industryPayload));
    }
    formData.append('articleViewableTo', value.articleViewableTo);

    formData.append(
      'articleViewableUserType',
      value.articleViewableUserType[0] === 'All Users' ? ['All'] : value.articleViewableUserType
    );

    formData.append('isPublished', isPublished.toString());

    if (['application/pdf', 'text/csv'].includes(textFile?.type)) {
      formData.append('file', textFile);
    }
    if (watchArticleType === 'Video') {
      if (videoFile) {
        formData.append('file', videoFile);
      }
    }
    if (watchArticleType === 'Video') {
      if (!videoFile) {
        setVideoError('Video file is required for Video type.');
        setAddEditSubmitLoader(false);
        return;
      }
    }
    if (watchArticleType === 'Audio') {
      if (audioFile) {
        formData.append('file', audioFile);
      }
    }
    if (watchArticleType === 'Audio') {
      if (!audioFile) {
        setAudioError('Audio file is required for Audio type.');
        setAddEditSubmitLoader(false);
        return;
      }
    }
    if (watchArticleType === 'Text') {
      if (!textFile) {
        if (['application/pdf', 'text/csv'].includes(value.fileUrl)) {
          formData.append('file', value.fileUrl);
        }
      }
    }
    if (editCoverImg) {
      formData.append('coverImage', editCoverImg);
    }

    if (!coverImageUrl && !editCoverImg) {
      setImgError('Cover image is required');
      setAddEditSubmitLoader(false);
      return;
    }

    if (action === 'Add') {
      // formData.append('topic', value.topic);
      try {
        const response = await API.createArticle({
          data: formData,
          orgId: orgId,
          groupId:  (resolvedGroupId || manualBuilderGroupId) ?? '',
          helpSettings: false
        });

        if (response.status === 200 && response.data.message === 'Article Created Successfully') {
          setAddEditSubmitLoader(false);
          dispatch(articleActions.addArticle(response.data.createArticleResponse));

          if (orgId && resolvedGroupId) {
            dispatch(
              fetchAllArticles({
                orgId: orgId,
                groupId: manualBuilderGroupId || resolvedGroupId,
                helpSettings: false,
                useCache: false
              })
            );
          }
          console.log('new article response', response)
          clearAll();
          toast.success('Article created successfully');
          setValue('articleName', '');
          reset();
          if (onNewArticleCreated) {
            onNewArticleCreated(response.data.createArticleResponse);
          }
          setOpenForm(false);
          setCoverImageUrl(null);
        } else if (
          response.status === 200 &&
          response.data.message === "You don't have permission to access this API"
        ) {
          toast.error("You don't have permission to add an article");
          reset();
          setOpenForm(false);
        } else {
          throw new Error('Failed to create article');
        }
      } catch (error) {
        setAddEditSubmitLoader(false);
        toast.error('Something went wrong, please try again');
      }
    }

    if (action === 'Edit') {
      try {
        const response = await API.editArticle({
          data: formData,
          orgId: orgId,
          articleId: selectedActiveId,
          groupId: manualBuilderGroupId || resolvedGroupId,
          helpSettings: false,
          location: singleListData.location
        });
        if (response.status === 200) {
          setAddEditSubmitLoader(false);
          dispatch(articleActions.updateArticle(response.data.updatedArticle));
          if (orgId && resolvedGroupId) {
            dispatch(
              fetchAllArticles({
                orgId: orgId,
                groupId: manualBuilderGroupId || resolvedGroupId,
                helpSettings: false,
                useCache: false
              })
            );
          }
          toast.success('Article updated successfully');
          setOpenForm(false);
          setCoverImageUrl(null);
          reset();
        }
      } catch (error) {
        setAddEditSubmitLoader(false);
        toast.error('Something went wrong, please try again.');
        console.log(error);
      }
    }

    reset();
    setValue('articleName', '');
    setValue('authorName', '');
    setValue('topic', '');
    setEditorState(EditorState.createWithContent(ContentState.createFromText('')));
  };

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setIsPublished(checked);
  };

  const handlePhotoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setImgError('');
    const photo = event.target.files ? event.target.files[0] : null;
    if (!photo) {
      setCoverImageUrl(null);
      setImgError('Cover image is required');
      return;
    }
    if (photo && photo.size > imgSize.limitValue) {
      setImgError('We cannot upload this file, please try another.');
      return;
    }
    if (photo) {
      const fileType = photo.type.toLowerCase();
      if (fileType === 'image/jpeg' || fileType === 'image/jpg' || fileType === 'image/png') {
        handleImageCompression(photo)
          .then((compressedImage) => {
            if (compressedImage) {
              clearErrors('coverImg');
              setCoverImageUrl(compressedImage);
            }
          })
          .catch((error) => {
            // console.error("Error", error);
          });
      } else {
        setImgError('Only JPG, JPEG and PNG files are allowed for the cover image.');
        return;
      }
    }
  };

  const handleRemoveImageFile = () => {
    setCoverImageUrl(null);
    const inputElement = document.getElementById('coverImgInput') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = '';
    }
    setEditCoverImg('');
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];

    if (file) {
      if (file.size > 100 * 1024 * 1024) {
        setVideoError('File size is too large. Maximum allowed size is 100MB.');
      } else {
        setVideoFile(file);
        setVideoError(null);
      }
    } else {
      setVideoFile(null);
      setVideoError('Video file is required for Video type.');
    }
  };

  const handleRemoveVideoFile = () => {
    setVideoFile(null);
    setEditVideoUrl(null);
  };

  const handleAudioFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      if (file.size > 100 * 1024 * 1024) {
        setAudioError('File size is too large. Maximum allowed size is 100MB.');
      } else {
        setAudioFile(file);
        setAudioError(null);
      }
    } else {
      setAudioFile(null);
      setAudioError('Audio file is required for Audio type.');
    }
  };

  const handleTextFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const targetFile: any = e.target.files && e.target.files[0];

    if (targetFile) {
      const fileExtension = targetFile.name.split('.').pop(); // Extract the file extension

      const file = new File(
        [targetFile],
        watch('articleName') ? watch('articleName') + `.${fileExtension}` : `attachment.${fileExtension}`,
        {
          type: targetFile.type
        }
      );

      if (file) {
        if (file.size > 100 * 1024 * 1024) {
          setTextFileError('File size is too large. Maximum allowed size is 100MB.');
        } else {
          if (fileExtension === 'pdf' || fileExtension === 'csv') {
            setTextFile(file);
          } else {
            setTextFileError('Unsupported file type. Please upload a PDF or CSV file.');
          }

          setTextFileError(null);
        }
      } else {
        setTextFile(null);
        setTextFileError('Audio file is required for Audio type.');
      }
    } else {
      setTextFile(null);
      setTextFileError('No file selected.');
    }
  };

  const handleRemoveAudioFile = () => {
    setAudioFile(null);
    setEditAudioUrl(null);
  };

  const handleEditorStateChange = (editorState: EditorState) => {
    setEditorState(editorState);

    const contentState = editorState.getCurrentContent();
    // const blockMap = contentState.getBlockMap();
    // let hasEmbeddedContent = false;
    let newContentState = contentState;

    // contentState.getBlockMap().forEach((block: any) => {
    //   const text = block.getText();
    //   // const urlRegex = /((https?:\/\/)?(www\.\S+\.(com|org|net|in|info|io)|\S+\.(com|org|net|in|info|io)))/g;
    //   const urlRegex = /(https?:\/\/)?(www\.\S+\.(com|org|net|in|info|io)|\S+\.(com|org|net|in|info|io))\S*/g;
    //   const matches = Array.from(text.matchAll(urlRegex));

    //   matches.forEach((match: any) => {
    //     const [url] = match;
    //     const start = match.index;
    //     const end = start + url.length;
    //     const existingEntityKey = block.getEntityAt(start);

    //     if (!existingEntityKey) {
    //       const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.svg'];
    //       const isImageURL = imageExtensions.some((extension) => url.endsWith(extension));

    //       const correctedUrl = url.startsWith('http://') || url.startsWith('https://') ? url : `https://${url}`;
    //       const contentStateWithLink = newContentState.createEntity('LINK', 'MUTABLE', { url: correctedUrl });
    //       const linkEntityKey = contentStateWithLink.getLastCreatedEntityKey();
    //       newContentState = Modifier.applyEntity(
    //         newContentState,
    //         SelectionState.createEmpty(block.getKey()).merge({
    //           anchorOffset: start,
    //           focusOffset: end
    //         }),
    //         linkEntityKey
    //       );
    //     }
    //   });
    // });

    const newState = EditorState.push(editorState, newContentState, 'apply-entity');
    setEditorState(newState);

    const htmlContent = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    // console.log("htmlContent",htmlContent);
    setValue('articleDescription', htmlContent);
    clearErrors('articleDescription');
  };

  const insertImage = (editorState: EditorState, imageUrl: string, altImage: string) => {
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity('IMAGE', 'IMMUTABLE', { src: imageUrl, alt: altImage });
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

    const newEditorState = AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');

    return newEditorState;
  };

  const handlePaste = useCallback(
    (event: ClipboardEvent) => {
      const items = event.clipboardData?.items;
      if (!items) return;

      for (const item of items) {
        if (item.type.indexOf('image') === 0) {
          const file = item.getAsFile();
          if (file) {
            imageUpload(file, 400, 400, 0.5)
              .then((response: any) => {
                if (response.data.link) {
                  const imageUrl = response.data.link;
                  const altImage = 'image';
                  const width = '400px';
                  // Insert the uploaded image into the editor
                  const newEditorState = insertImage(editorState, imageUrl, altImage);
                  setEditorState(newEditorState);
                  // Prevent the default paste behavior
                  event.preventDefault();
                  return;
                }
              })
              .catch((error: any) => {
                console.error('Image upload error:', error);
              });
          }
        }
      }
    },
    [editorState]
  );

  useEffect(() => {
    const editorContainer = document.querySelector('.editorClassName');
    if (editorContainer) {
      editorContainer.addEventListener('paste', handlePaste as any);
    }

    return () => {
      if (editorContainer) {
        editorContainer.removeEventListener('paste', handlePaste as any);
      }
    };
  }, [handlePaste]);

  const compressImage = (file: any, maxWidth: any, maxHeight: any, quality: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let { width } = img;
          let { height } = img;

          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }

          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext('2d');
          ctx?.drawImage(img, 0, 0, width, height);

          canvas.toBlob(
            (blob: any) => {
              const compressedFile = new File([blob], file.name, {
                type: file.type,
                lastModified: file.lastModified
              });

              const compressedReader = new FileReader();
              compressedReader.onload = (compressedE: any) => {
                resolve(compressedE.target.result);
              };
              compressedReader.onerror = (error) => {
                reject(error);
              };
              compressedReader.readAsDataURL(compressedFile);
            },
            file.type,
            quality
          );
        };
        img.src = e.target.result;
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  };

  const readAsDataURL = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        resolve({ data: { link: e.target.result } });
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  };

  const formData = new FormData();

  const uploadArticleDescriptionFile = async (file: File) => {
    formData.append('file', file);
    try {
      const result = await API.saveArticleDescriptionFiles(formData);
      const blobUrl = _.get(_.head(_.get(result, 'data.data')), 'Bloburl', '');
      return { data: { link: blobUrl } };
    } catch {
      return Error('Failed to upload');
    }
  };

  const imageUpload = async (file: any, maxWidth: any = 400, maxHeight: any = 400, quality: any = 1.0) => {
    if (!acceptedImages.includes(file.type)) {
      return { error: 'Image upload failed' };
    } else {
      try {
        // if (file.size <= 1024 * 1024) {
        //   return await readAsDataURL(file);
        // }
        // const imageDataUrl = await handleImageCompression(file)
        // return await readAsDataURL(imageDataUrl)
        // const imageDataUrl = await compressImage(file, maxWidth, maxHeight, quality);

        if (file.size <= 1024 * 1024) {
          const result = await uploadArticleDescriptionFile(file);
          return result;
        } else {
          const reSizedFile = await handleImageCompression(file);
          if (reSizedFile) {
            const result = await uploadArticleDescriptionFile(reSizedFile);
            return result;
          }
        }
      } catch (error) {
        console.error('Image upload error:', error);
        return { error: 'Image upload failed' };
      }
    }
  };

  const blockRender = (contentBlock: any) => {
    const entityKey = contentBlock.getEntityAt(0);
    const contentState = editorState.getCurrentContent();

    if (contentBlock.getType() === 'atomic' || contentBlock.text === '📷') {
      return {
        component: ImageBlock,
        editable: false,
        props: {
          block: contentBlock,
          // contentState,
          blockProps: {
            editorState,
            setEditorState
          }
        }
      };
    }
    return null;
  };

  // const imageUpload = (file: any) => {

  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.onload = (e: any) => {
  //       resolve({ data: { link: e.target.result } });
  //     };
  //     reader.onerror = (e) => {
  //       reject(e);
  //     };
  //     reader.readAsDataURL(file);
  //   });
  // };

  useEffect(() => {
    if (singleListData && action === 'Edit') {
      console.log(singleListData)
      for (const field in singleListData) {
        setValue(field, singleListData[field]);
      }
      const { articleDescription, isPublished, coverImageUrl, fileUrl } = singleListData;
      console.log({ articleDescription, isPublished, coverImageUrl, fileUrl })
      setUrlName(fileUrl);
      if (/\.(mp4|webm|ogg|ogv)$/i.test(fileUrl)) {
        setVideoFile(fileUrl);
        setEditVideoUrl(fileUrl);
      }
      if (/\.(mp3|wav|ogg)$/i.test(fileUrl)) {
        setAudioFile(fileUrl);
        setEditAudioUrl(fileUrl);
      }
      if (_.get(singleListData, 'type') === 'Text') {
        setTextFileUrl(fileUrl);
      }
      setValue('articleDescription', articleDescription);
      setValue('coverImg', coverImageUrl);
      setIsPublished(isPublished);
      setEditCoverImg(coverImageUrl);
      const { contentBlocks } = htmlToDraft(articleDescription ?? '');
      const editorState = EditorState.createWithContent(ContentState.createFromBlockArray(contentBlocks));
      setEditorState(editorState);
    }
  }, [singleListData, action]);

  const embedCallback = (url: any) => {
    if (url.indexOf('youtube') >= 0) {
      url = url.replace('watch?v=', 'embed/');
      url = url.replace('/watch/', '/embed/');
      url = url.replace('youtu.be/', 'youtube.com/embed/');
    }
    return url; // Return the modified URL or the original URL
  };

  const clearAll = () => {
    setImgError('');
    setVideoFile(null);
    reset();
    setCoverImageUrl(null);
    setEditCoverImg('');
    setEditorState(EditorState.createWithContent(ContentState.createFromText('')));
    setEditVideoUrl(null);
    setAudioFile(null);
    setEditAudioUrl(null);
    setTextFileUrl(null);
    setTextFile(null);
  };
  useEffect(() => {
    if (action === 'Add' && openForm) {
      clearAll();
    }
  }, [action, openForm]);

  useEffect(() => {
    clearAll();
    setValue('type', '');
    setValue('readTime', '');
    // setValue('accessFor', '');
  }, []);

  const handleRemoveTextFileUrl = () => {
    setTextFile(null);
    setTextFileUrl(null);
  };

  const handleUserTypeChange = (event: any, value: string[]) => {
    if (value?.length > 0) {
      if (value?.includes('All Users')) {
        value = ['All Users'];
      }
      setValue('articleViewableUserType', value);
      setError('articleViewableUserType', { message: '' });
    } else {
      setValue('articleViewableUserType', []);
      setError('articleViewableUserType', { message: 'at least one member is required' });
    }
  };

  return (
    <Dialog
      open={openForm}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableEnforceFocus
      fullWidth
      maxWidth="md"
      PaperProps={{
        sx: {
          bgcolor: '#0F0F0F',
          border: '1px solid #444444',
          borderRadius: 2,
          overflow: 'hidden'
        }
      }}
    >
      <CommonModalHeader
        title={action === 'Edit' ? 'Edit Content' : 'New Content Drop'}
        handleCloseModal={handleClickCloseForm}
      />
      <DialogContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box display="flex" alignItems="center" gap="10px">
            <UiSwitch checked={isPublished} onChange={handleSwitchChange} />
            <Typography sx={{ color: '#FDFDFD', fontSize: 14 }}>Visible to others</Typography>
          </Box>

          <Controller
            name="articleName"
            control={control}
            render={({ field: { onChange, value } }) => (
              <DosenInput
                label="Article Name *"
                name="articleName"
                value={value || ''}
                id="helpArticleName"
                type="text"
                placeholder="Article Name"
                onChange={onChange}
                error={checkError('articleName')}
                helperText={getError('articleName')?.toString()}
              />
            )}
          />

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Controller
                name="type"
                control={control}
                rules={{ required: true }}
                defaultValue={type}
                render={({ field }) => (
                  <UiSelect
                    label="Article Type *"
                    placeholder="Select"
                    value={field.value || ''}
                    onChange={(event) => {
                      field.onChange(event);
                    }}
                    options={[
                      { label: 'Text', value: 'Text' },
                      { label: 'Audio', value: 'Audio' },
                      { label: 'Video', value: 'Video' }
                    ]}
                    errorText={getError('type')?.toString()}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Controller
                name="readTime"
                control={control}
                defaultValue={readTimeValue}
                render={({ field }) => (
                  <UiSelect
                    label="Read Time *"
                    placeholder="Select"
                    value={field.value || ''}
                    onChange={(event) => field.onChange(event)}
                    options={[
                      { label: '1 Min', value: '1 Min' },
                      { label: '2 Min', value: '2 Min' },
                      { label: '3 Min', value: '3 Min' },
                      { label: '4 Min', value: '4 Min' },
                      { label: '5 Min', value: '5 Min' },
                      { label: '10 Min', value: '10 Min' },
                      { label: '15 Min', value: '15 Min' },
                      { label: '15+ Min', value: '15+ Min' }
                    ]}
                    errorText={getError('readTime')?.toString()}
                  />
                )}
              />
            </Grid>
          </Grid>

        <Box display="flex" alignItems="center" margin="20px 0">
          {!editCoverImg && (
            <>
              <Box
                sx={{
                  width: '100px',
                  height: '70px',
                  background: '#444444',
                  border: '1px solid #868686',
                  marginRight: '12px',
                  borderRadius: '6px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                  cursor: 'pointer'
                }}
              >
                <Controller
                  name="coverImg"
                  control={control}
                  render={({ field }) => (
                    <label>
                      <input
                        id="coverImgInput"
                        name={field.name}
                        hidden
                        accept="image/*"
                        type="file"
                        onChange={(e) => {
                          if (e.target.files && e.target.files.length > 0) {
                            const file = e.target.files[0];
                            field.onChange(file);
                            handlePhotoChange(e);
                          }
                        }}
                      />
                      <CameraAltOutlinedIcon
                        className="AddContentCameraIcon"
                        sx={{ color: !coverImageUrl && !_.head(coverImageUrl) ? '#868686' : '#FFFFFF' }}
                      />
                      {coverImageUrl && (
                        <img
                          src={URL.createObjectURL(coverImageUrl)}
                          style={{
                            width: '100px',
                            height: '70px',
                            objectFit: 'cover',
                            borderRadius: '6px'
                          }}
                          loading="lazy"
                          alt=""
                        />
                      )}
                    </label>
                  )}
                />
              </Box>
              <Box>
                <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 500 }}>Cover Image *</Typography>
                <Typography fontSize="12px" fontWeight="500" color={'#868686'}>
                  *Only JPG, PNG, SVG, or GIF (max. 800x800 px)
                </Typography>
              </Box>
            </>
          )}
          {editCoverImg && (
            <Box
              sx={{
                width: '100px',
                height: '70px',
                margin: '0 20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: 'none'
              }}
            >
              <img
                src={editCoverImg}
                style={{
                  objectFit: 'contain',
                  width: '100%',
                  height: '100%'
                }}
                loading="lazy"
                alt=""
              />
            </Box>
          )}
          {editCoverImg && (
            <Box>
              <Typography
                variant="subtitle2"
                fontSize="10px"
                color="error"
                onClick={handleRemoveImageFile}
                className="cursor-pointer"
              >
                Remove
              </Typography>
            </Box>
          )}
          {imgError && <FormHelperText error>{imgError} </FormHelperText>}
          {!imgError && <FormHelperText error>{getError('coverImg')?.toString()}</FormHelperText>}
        </Box>

        {watchArticleType === 'Video' && (
          <div>
            <div>
              {!videoFile && !editVideoUrl && (
                <div
                  style={{
                    background: '#0F0F0F',
                    border: '1px dashed #868686',
                    color: '#FDFDFD',
                    borderRadius: '8px',
                    padding: '5px 46px 15px',
                    margin: '15px 0',
                    textAlign: 'center'
                  }}
                >
                  <input type="file" id="file" accept="video/mp4" onChange={handleFileChange} className="d-none" />
                  <IconButton>
                    <label htmlFor="file">
                      <img src={upload} alt="upload" width="25px" height="25px" />
                    </label>
                  </IconButton>
                  <div
                    style={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 500,
                      fontSize: '12px',
                      color: '#B6B6B6'
                    }}
                  >
                    <label htmlFor="file">
                      <span style={{ color: '#3D8BFD', fontSize: '14px' }}>Click to upload</span>
                    </label>
                    {' or drag '}
                    <br />
                    Article Video File (max. 100 MB)
                  </div>
                </div>
              )}
              <div style={{ display: 'flex' }}>
                <div style={{ borderRadius: '8px 8px 8px 8px' }}>
                  {videoFile && videoFile.type && videoFile.type.startsWith('video/') && (
                    <video
                      style={{ borderRadius: '8px 8px 8px 8px' }}
                      src={URL.createObjectURL(videoFile)}
                      width="320"
                      height="240"
                      controls
                    />
                  )}
                  {editVideoUrl && (
                    <video
                      style={{ borderRadius: '8px 8px 8px 8px' }}
                      src={
                        editVideoUrl
                          ? typeof editVideoUrl === 'string'
                            ? editVideoUrl
                            : URL.createObjectURL(editVideoUrl)
                          : undefined
                      }
                      width="320"
                      height="240"
                      controls
                    />
                  )}
                </div>
                <div
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 600,
                    fontSize: '14px',
                    color: '#FDFDFD',
                    marginTop: '10px',
                    margin: 'auto',
                    marginLeft: '1%'
                  }}
                >
                  <span>
                    {/* {videoFile && videoFile.name ? videoFile.name : filename} */}
                    {videoFile && (
                      <span className="cursor-pointer" onClick={handleRemoveVideoFile}>
                        {' '}
                        X
                      </span>
                    )}
                    {/* {editVideoUrl instanceof File && editVideoUrl.name && <span>{editVideoUrl.name}</span>}
                    {editVideoUrl instanceof File && !editVideoUrl.name && <span>No file name available</span>} */}
                  </span>
                </div>
              </div>
              {videoError && <FormHelperText error>{videoError}</FormHelperText>}
            </div>
          </div>
        )}
        {watchArticleType === 'Audio' && (
          <div>
            {!audioFile && !editAudioUrl && (
              <div
                style={{
                  background: '#0F0F0F',
                  border: '1px dashed #868686',
                  borderRadius: '8px',
                  padding: '5px 46px 15px',
                  margin: '15px 0',
                  textAlign: 'center'
                }}
              >
                <input
                  type="file"
                  id="audioFile"
                  accept="audio/mp3"
                  onChange={handleAudioFileChange}
                  className="d-none"
                />
                <IconButton>
                  <label htmlFor="audioFile">
                    <img
                      src={upload}
                      alt="upload"
                      style={{
                        padding: 0,
                        margin: 0,
                        width: '25px',
                        height: '25px'
                      }}
                    />
                  </label>
                </IconButton>
                  <div
                    style={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 500,
                      fontSize: '12px',
                      color: '#B6B6B6'
                    }}
                  >
                  <label htmlFor="audioFile">
                    <span style={{ color: '#3D8BFD', fontSize: '14px' }}>Click to upload</span>
                  </label>
                  {' or drag '}
                  <br />
                  Article Audio File (max. 100 MB)
                </div>
              </div>
            )}

            <div style={{ display: 'flex' }}>
              <div style={{ borderRadius: '8px' }}>
                {audioFile?.type?.startsWith('audio/') && (
                  <audio style={{ borderRadius: '8px' }} src={audioFile && URL.createObjectURL(audioFile)} controls>
                    Your browser does not support the audio element.
                  </audio>
                )}

                {editAudioUrl && (
                  <>
                    <audio
                      style={{ borderRadius: '8px' }}
                      src={
                        editAudioUrl
                          ? typeof editAudioUrl === 'string'
                            ? editAudioUrl
                            : URL.createObjectURL(editAudioUrl)
                          : undefined
                      }
                      controls
                    />
                    <p>{editAudioUrl.name}</p>
                  </>
                )}
              </div>
              {audioFile && (
                <div
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 600,
                    fontSize: '14px',
                    color: '#FDFDFD',
                    marginTop: '10px',
                    margin: 'auto',
                    marginLeft: '1%'
                  }}
                >
                  {/* <span>{watchArticleType === 'Audio' ? (audioFile.name ? audioFile.name : filename) : ''}</span> */}
                  <span className="cursor-pointer" onClick={handleRemoveAudioFile}>
                    {' '}
                    X
                  </span>
                </div>
              )}
            </div>
            {audioError && <FormHelperText error>{audioError}</FormHelperText>}
          </div>
        )}

        {/* abcd */}
        {watchArticleType === 'Text' && (
          <div>
            {!textFile && !textFileUrl && (
              <div
                style={{
                  background: '#0F0F0F',
                  border: '1px dashed #868686',
                  borderRadius: '8px',
                  padding: '5px 46px 15px',
                  margin: '15px 0',
                  textAlign: 'center'
                }}
              >
                <input
                  type="file"
                  id="textFile"
                  accept="application/pdf,.csv"
                  className="d-none"
                  onChange={handleTextFileChange}
                />

                <IconButton>
                  <label htmlFor="textFile">
                    <img
                      src={upload}
                      alt="upload"
                      style={{
                        padding: 0,
                        margin: 0,
                        width: '25px',
                        height: '25px'
                      }}
                    />
                  </label>
                </IconButton>
                  <div
                    style={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 500,
                      fontSize: '12px',
                      color: '#B6B6B6'
                    }}
                  >
                  <label htmlFor="textFile">
                    <span style={{ color: '#3D8BFD', fontSize: '14px' }}>Click to upload</span>
                  </label>
                  {' or drag '}
                  <br />
                  Article Text File (max. 100 MB)
                </div>
              </div>
            )}
            <div style={{ display: 'flex' }}>
              <div style={{ borderRadius: '8px' }}>{textFileUrl && <p>{textFileUrl?.name}</p>}</div>
              {(textFile || textFileUrl) && (
                <div
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 600,
                    fontSize: '14px',
                    color: '#FDFDFD',
                    marginTop: '10px',
                    marginBottom: '10px',
                    margin: 'auto',
                    marginLeft: '1%'
                  }}
                >
                  <span
                    onClick={() =>
                      textFileUrl?.includes('http')
                        ? window.open(textFileUrl, '_blank')
                        : blobTextFileUrl
                        ? window.open(blobTextFileUrl, '_blank')
                        : null
                    }
                    style={{
                      color: '#FDFDFD',
                      textDecorationLine: 'underline',
                      cursor: 'pointer',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 6
                    }}
                  >
                    <FileOutlined /> {watchArticleType === 'Text' ? (textFile?.name ? textFile.name : filename) : ''}
                  </span>
                  <IconButton onClick={handleRemoveTextFileUrl}>
                    <Close fontSize="small" color="error" />
                  </IconButton>
                </div>
              )}
            </div>
            {textFileError && <FormHelperText error>{textFileError}</FormHelperText>}
          </div>
        )}
        <Grid container spacing={2}>
          <Grid item md={6}>
            <Controller
              name="authorName"
              control={control}
              render={({ field: { onChange, value } }) => (
                <DosenInput
                  label="Author Name *"
                  name="authorName"
                  value={value || ''}
                  id="helpAuthorName "
                  type="text"
                  placeholder="Author Name"
                  onChange={onChange}
                  error={checkError('authorName')}
                  helperText={getError('authorName')?.toString()}
                />
              )}
            />
          </Grid>
          {/* <Grid item md={6}>
            <InputLabel>
              Who can view *
            </InputLabel>

            <FormControl fullWidth variant="outlined">
              <Controller
                name="accessFor"
                control={control}
                defaultValue={viewFor}
                render={({ field }) => (
                  <Select
                    id="accessFor"
                    placeholder="Select"
                    {...field}
                    error={!!errors.accessFor}
                    displayEmpty
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <span
                            style={{
                              fontFamily: 'Open Sans',
                              fontSize: '14px',
                              fontWeight: '400',
                              color: '#DCE0E4'
                            }}
                          >
                            Who can view
                          </span>
                        );
                      }
                      return selected;
                    }}
                  >
                    <MenuItem value="Public">Public</MenuItem>
                    <MenuItem value="Private">Private</MenuItem>
                  </Select>
                )}
              />
              <FormHelperText error>{getError('accessFor')?.toString()}</FormHelperText>
            </FormControl>
          </Grid> */}
          <Grid item md={6}>
            <Controller
              name="articleViewableTo"
              control={control}
              defaultValue={''}
              render={({ field }) => (
                <UiSelect
                  label="Article Viewable To *"
                  placeholder="Select"
                  value={getValues('articleViewableTo') || field.value || ''}
                  onChange={(event) => field.onChange(event)}
                  options={[
                    { label: 'All of Dosen', value: 'All of Dosen' },
                    { label: 'Organization-wide', value: 'Organization-wide' },
                    { label: 'Program only', value: 'Program only' }
                  ]}
                  errorText={getError('articleViewableTo')?.toString()}
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="articleViewableUserType"
              control={control}
              defaultValue={[]} // Initialize with an empty array
              render={({ field: { onChange, value } }) => (
                <DosenAutocomplete
                  multiple
                  // options={[]}
                  options={roleOptions}
                  getOptionLabel={(option: any) => _.startCase(roleNameFormatter(option, mentorRoleText, menteeRoleText))}
                  value={value}
                  id="helpArticleAccessibleTo"
                  // onChange={(_, newValue) => onChange(newValue)} // Pass the new value array
                  onChange={(event: any, value: any) => {
                    handleUserTypeChange(event, value);
                  }} // Pass the new value array
                  disableCloseOnSelect
                  renderInput={(params: any) => (
                    <UiInput
                      {...params}
                      error={getError('articleViewableUserType') ? true : false}
                      fullWidth
                      placeholder="Article Accessible To"
                    />
                  )}
                  // placeholder='Article Accessible To'
                  getOptionDisabled={(option: any) => {
                    return value?.includes('All Users') && option !== value[0];
                  }}
                />
              )}
            />
            <FormHelperText error>
              {checkError('articleViewableUserType') && getError('articleViewableUserType')?.toString()}
            </FormHelperText>
          </Grid>
          {/* {topicOptions.length > 0 && (
            <Grid item xs={12}>
              <Box sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 500, mb: 0.5 }}>Topics *</Box>
              <Controller
                name="tags"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    id="topics"
                    size="small"
                    multiple
                    value={field.value || []}
                    onChange={(event, newValue) => {
                      setValue('tags', newValue);
                      errors['tags'] = undefined;
                    }}
                    options={topicOptions}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    disableCloseOnSelect
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        background: 'rgba(0,0,0,0.70)',
                        color: '#FDFDFD',
                        borderRadius: '6px',
                        outline: '1px solid #868686',
                        '&:hover': { outlineColor: '#B4B4B4' },
                        '&.Mui-focused': { outlineColor: '#F79420' },
                        '& .MuiOutlinedInput-notchedOutline': { border: 'none' }
                      }
                    }}
                    renderInput={(params) => (
                      <UiInput
                        {...params}
                        placeholder="Select"
                        error={checkError('tags')}
                        helperText={getError('tags')?.toString()}
                      />
                    )}
                  />
                )}
              />
            </Grid>
          )}
          {industryOptions.length > 0 && (
            <Grid item xs={12}>
              <Box sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 500, mb: 0.5 }}>Industry *</Box>
              <Controller
                name="industries"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    id="industry"
                    size="small"
                    multiple
                    options={industryOptions}
                    onChange={(event, newValue) => {
                      newValue ? setValue('industries', newValue) : setValue('industries', '');
                      errors['industries'] = undefined;
                    }}
                    value={field.value || []}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        background: 'rgba(0,0,0,0.70)',
                        color: '#FDFDFD',
                        borderRadius: '6px',
                        outline: '1px solid #868686',
                        '&:hover': { outlineColor: '#B4B4B4' },
                        '&.Mui-focused': { outlineColor: '#F79420' },
                        '& .MuiOutlinedInput-notchedOutline': { border: 'none' }
                      }
                    }}
                    renderInput={(params) => (
                      <UiInput
                        {...params}
                        placeholder="Select"
                        error={checkError('industries')}
                        helperText={getError('industries')?.toString()}
                      />
                    )}
                    getOptionLabel={(option) => option}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    disableCloseOnSelect
                    freeSolo
                  />
                )}
              />
            </Grid>
          )} */}
          {/* <Grid item md={12}>
            <InputLabel>Topic</InputLabel>
            <FormControl fullWidth>
              <Controller
                name="topic"
                control={control}
                render={({ field }) => (
                  <Autocomplete
                    id="helpTopic"
                    size="small"
                    // Remove 'multiple' prop to disallow multiple selections
                    value={field.value || null} // Update value prop to be a single value or null
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setValue('topic', newValue);
                        setError('topic', { message: undefined });
                      } else {
                        setValue('topic', '');
                        setError('topic', { message: 'Select a topic' });
                      }
                    }}
                    filterOptions={(options, params) => {
                      if (!Array.isArray(options)) {
                        options = [];
                      }
                      const filtered = options?.filter(
                        (option) =>
                          typeof option === 'string' &&
                          option.toLowerCase().indexOf(params.inputValue.toLowerCase()) !== -1
                      );

                      if (params.inputValue !== '') {
                        filtered.push(`${params.inputValue}`);
                      }

                      return filtered;
                    }}
                    options={TagList || []}
                    getOptionLabel={(option) => option}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    freeSolo
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Select"
                        error={getError('topic')?.toString() ? checkError('topic') : false}
                      />
                    )}
                  />
                )}
              />
              <FormHelperText error>{getError('topic')?.toString()}</FormHelperText>
            </FormControl>
          </Grid> */}
          <Grid item md={12}>
            <Box sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 500, mb: 0.5 }}>Article Description *</Box>
            <Box
              style={{
                width: '100%'
              }}
            >
              <Controller
                name="articleDescription"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <>
                    <Editor
                      editorStyle={{
                        margin: '0px',
                        paddingLeft: '3px',
                        fontFamily: 'Inter, sans-serif',
                        background: 'rgba(0,0,0,0.7)',
                        color: '#FDFDFD',
                        minHeight: '120px'
                      }}
                      wrapperStyle={{
                        padding: 0,
                        border: '1px solid #868686',
                        borderRadius: '6px'
                      }}
                      toolbarStyle={{
                        ...toolBarStyle,
                        backgroundColor: '#1C1C1C',
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0
                      }}
                      toolbar={{
                        image: {
                          popupClassName: 'articleImage-modal',
                          inputAccept: acceptedImages,
                          uploadCallback: imageUpload,
                          previewImage: true
                        },
                        embedded: {
                          embedCallback: embedCallback
                        }
                      }}
                      customBlockRenderFunc={blockRender}
                      editorClassName="editorSize contentEditorClass"
                      editorState={editorState}
                      onEditorStateChange={handleEditorStateChange}
                      placeholder="Write your article description here"
                      toolbarClassName="toolbar-class custom-modal"
                      wrapperClassName="wrapperClassName wrapper-class custom-header-dropdown"
                    />

                    <FormHelperText error> {getError('articleDescription')?.toString()}</FormHelperText>
                  </>
                )}
              />
            </Box>
          </Grid>
        </Grid>
        {/* Form Code End */}
        </Box>
      </DialogContent>
      <DialogActions style={{ padding: '15px 20px', justifyContent: 'center' }}>
        <LoadingButton
          style={
            addEditSubmitLoader
              ? {}
              : {
                  fontFamily: 'Open Sans',
                  fontSize: '16px',
                  fontWeight: '700',
                  color: '#fff',
                  background: 'linear-gradient(180deg, #F79420 0%, #F15A26 100%)',
                  borderRadius: '8px',
                  width: '560px',
                  height: '50px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer'
                }
          }
          loading={addEditSubmitLoader}
          onClick={handleSubmit(onSubmit)}
        >
          {action === 'Edit' ? 'Save' : 'Add New Content'}
        </LoadingButton>{' '}
      </DialogActions>
    </Dialog>
  );
};

export default AddEditContent;
